import { useQuery } from "@tanstack/react-query";
import { getJSON } from "@/utils/fetcher";

export function useRecentDeposits(limit: number = 10) {
  return useQuery({
    queryKey: ["vault-deposits", "recent", limit],
    queryFn: async () => {
      const data = await getJSON<any[]>("/api/earn/vault-deposits");
      return data.slice(0, limit);
    },
    staleTime: 5000,
    refetchInterval: 5000,
  });
}
